import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { Suspense } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Router from './routes';
import ThemeProvider from './theme';
import PageSpinner from 'components/PageSpinner';
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import ServerStoreProvider from './serverStore/ServerStoreProvider';
import './global.styles.css';
import AppErrorBoundary from 'components/AppErrorBoundary';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <ServerStoreProvider>
      <HelmetProvider>
        <BrowserRouter>
          <ThemeProvider>
            <ScrollToTop />
            <StyledChart />
            <Suspense fallback={<PageSpinner />}>
              <AppErrorBoundary>
                <Router />
                <ToastContainer />
              </AppErrorBoundary>
            </Suspense>
          </ThemeProvider>
        </BrowserRouter>
      </HelmetProvider>
    </ServerStoreProvider>
  );
}
